module.exports = "https://portperrypedals.ca/_res/img/natures-bounty.df7c49c.png";